module.exports = __webpack_public_path__ + "static/media/map_marker_alarm_active_icon.846a7fc2.svg";